import React, { useMemo, useCallback } from "react";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { NavLink } from "react-router-dom";
import { _MENU } from "./_menu_contants";
const hasAccess = (itemRoles = [], userRoles = []) =>
  itemRoles.length === 0 || itemRoles.some((r) => userRoles.includes(r));

export const MenuGroup = ({ userRoles }) => {
  const [openStates, setOpenStates] = React.useState({});

  const menuItems = useMemo(() => {
    return _MENU
      .filter((m) => hasAccess(m.roles, userRoles))
      .map((m) =>
        m.submenu
          ? {
              ...m,
              submenu: m.submenu.filter((s) => hasAccess(s.roles, userRoles)),
            }
          : m,
      );
  }, [userRoles]);

  // Ouvre un seul parent à la fois
  const toggleParent = useCallback((title) => {
    setOpenStates((prev) => {
      const isOpening = !prev[title];
      return isOpening ? { [title]: true } : {};
    });
  }, []);

  // Sur clic d’un sous-menu: maintenir son parent ouvert et fermer les autres
  const handleSubClick = useCallback((parentTitle) => {
    setOpenStates({ [parentTitle]: true });
  }, []);

  return (
    <List dense>
      {menuItems.map((item) => {
        const hasSub = item.submenu && item.submenu.length > 0;
        const parentOpen = !!openStates[item.title];
        return (
          <React.Fragment key={item.title}>
            <ListItemButton
              component={hasSub ? "div" : NavLink}
              to={hasSub ? undefined : item.path}
              onClick={() =>
                hasSub ? toggleParent(item.title) : setOpenStates({})
              }
            >
              {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
              <ListItemText primary={item.title} />
              {hasSub && (parentOpen ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>
            {hasSub && (
              <Collapse in={parentOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding dense>
                  {item.submenu.map((sub) => (
                    <ListItemButton
                      key={sub.title}
                      component={NavLink}
                      to={sub.path}
                      sx={{ pl: 4 }}
                      onClick={() => handleSubClick(item.title)}
                    >
                      {sub.icon && <ListItemIcon>{sub.icon}</ListItemIcon>}
                      <ListItemText primary={sub.title} />
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            )}
          </React.Fragment>
        );
      })}
    </List>
  );
};

export default MenuGroup;